import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Crown, ArrowRight, ShieldCheck } from "lucide-react";

/**
 * BigCapGateway — the glowing gold-bordered CTA rendered on every
 * buyer/seller Account dashboard. Status-aware: shows the right label +
 * destination based on the user's Big-Cap state.
 */
export function BigCapGateway({ status = "not_applied", membershipNo }) {
  const isMember = status === "inducted";
  const isReviewing = status === "under_scrutiny";
  const isRejected = status === "rejected";

  const label = isMember   ? "OPEN BIG-CAP LEAGUE DESK"
              : isReviewing ? "APPLICATION UNDER EXECUTIVE SCRUTINY"
              : isRejected  ? "REVIEW BIG-CAP DECISION"
              :               "REQUEST ACCESS TO BIG-CAP PROJECTS";
  const sub = isMember    ? `Member · ${membershipNo || "VNC/BC/…"}`
             : isReviewing ? "Vinci leadership reviewing your file · 10 business days"
             : isRejected  ? "Read the decision + re-apply after 90 days"
             :               "Financial power · infrastructure · loyalty · deposit-locked";
  const to = "/league";

  return (
    <Link to={to} data-testid="big-cap-gateway"
      className="group relative block overflow-hidden rounded-sm">
      {/* Gold pulse-ring */}
      <motion.span aria-hidden
        className="pointer-events-none absolute inset-0 rounded-sm border border-[#D8B23E]/50"
        animate={{ boxShadow: [
          "0 0 0 rgba(216,178,62,0.0)",
          "0 0 32px rgba(216,178,62,0.35)",
          "0 0 0 rgba(216,178,62,0.0)",
        ] }}
        transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut" }}
      />
      <div className="relative flex items-center gap-4 p-5 bg-gradient-to-r from-[#0a0a0a] via-[#111] to-[#0a0a0a]">
        <span className="grid place-items-center w-11 h-11 rounded-full bg-gradient-to-br from-[#D8B23E] to-[#B87333] text-black shrink-0">
          <Crown size={19}/>
        </span>
        <div className="flex-1">
          <div className="font-grotesk text-[10px] uppercase tracking-[0.28em] text-[#D8B23E]">Big-Cap Infrastructure League</div>
          <div className="font-serif text-xl text-[#F5F5F0] mt-0.5">{label}</div>
          <div className="font-body text-xs text-[#8A8A82] mt-1">{sub}</div>
        </div>
        {isMember ? (
          <span className="inline-flex items-center gap-1.5 rounded-full border border-[#D8B23E]/60 text-[#D8B23E] px-3 py-1 font-grotesk text-[9px] uppercase tracking-[0.22em]">
            <ShieldCheck size={11}/> VIP
          </span>
        ) : (
          <ArrowRight size={16} className="text-[#D8B23E] group-hover:translate-x-1 transition-transform"/>
        )}
      </div>
    </Link>
  );
}
